import {
  enterpriseInit,
  getEnterpriseID,
} from "@meitu/xdesign-widgets/dist/teamExports";
import {
  setConfigPartial,
  ENV_ENUM,
} from "@meitu/xdesign-widgets/dist/configProvider";
import { getClientID } from "@/constants";

export async function initEnterprise() {
  setConfigPartial({
    client_id: getClientID(),
    env: process.env.NEXT_PUBLIC_ENV as ENV_ENUM,
  });
  // 企业相关配置，目前主要使用到上传app
  const res = await enterpriseInit();
}

// 是否企业标识
export const isEnterprise = () => !!getEnterpriseID();
